type DateInput = Date | string | undefined;

export function formatDate(value: DateInput): string {
  if (!value) return "Unknown";
  try {
    const date = typeof value === "string" ? new Date(value) : value;
    if (Number.isNaN(date.getTime())) {
      return value.toString();
    }
    return date.toLocaleDateString();
  } catch {
    return value.toString();
  }
}

/**
 * Format a date-only string (YYYY-MM-DD) to a readable form like "Apr 4, 2026".
 * Parses as local date to avoid UTC timezone shifts.
 */
export function formatProgramDate(value: string | null | undefined): string {
  if (!value) return "—";
  try {
    // Parse YYYY-MM-DD as local date (avoids UTC midnight → previous day in negative-offset zones)
    const [year, month, day] = value.split("-").map(Number);
    if (!year || !month || !day) return value;
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return value;
  }
}


export function formatDistanceToNow(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString();
}

